export default {
  common: {
    account: 'アカウント',
    signOut: 'サインアウト'
  },
  views: {
    dashboard: {
      title: 'ダッシュボード',
      tokyo: '東京',
      osaka: '大阪'
    },
    seatMap: {
      title: '座席表',
      tokyoHirakuza: '東京日楽座',
      osakaHirakuza: '大阪日楽座',
      select: '選択',
      seatStatusOverview: '座席状況一覧',
      foodTypesAndReservations: '食事の種類と予約数',
      seatSection: '座席区分',
      usageAndTotal: '使用数・全体数',
      remaining: '残席数',
      actualArrival: '来場数・予約数',
      foodType: '種類',
      reservationCount: '予約数',
      release: '開放する',
      selectSeat: '座席選択',
      reloadData: 'データリロード',
      selectSeatMessage: '座席を選択してください。',
      releaseSuccess: '席を開放しました。',
      releaseError: '座席の開放に失敗しました。'
    },
    login: {
      username: 'ユーザー名',
      password: 'パスワード',
      signIn: 'ログイン',
      invalidLogin: '{{email}}はログインできません。'
    },
    redeem: {
      title: '入場QR読取',
      success: '引き換えに成功しました',
      fail: '引き換えに失敗しました',
      emptyCode: 'コードを入力してください',
      printerSettings: 'プリンターIPアドレス設定',
      printerIpPlaceholder: '192.168.1.1',
      save: '保存',
      testPrint: 'テスト印刷',
      emptyPrinterIp: 'プリンターのIPアドレスを入力してください',
      invalidPrinterIp: '有効なIPアドレスを入力してください（例: 192.168.1.1）',
      printerIpSaved: 'プリンターのIPアドレスが保存されました',
      terminalId: '端末ID'
    }
  },
  validation: {
    required: '{{name}}を入力してください',
    requiredSelect: '選択してください',
    invalid: '有効な{{name}}を入力してください',
    password: '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください',
    number: '半角数字を入力してください'
  }
};
